import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import { NavList } from "./NavList"

const ACFQuery = graphql`
  query {
    wpMenu(slug: { eq: "top-nav-en" }) {
      menuItems {
        nodes {
          path
          label
          id
          parentId
          menu_item_is_title {
            megaMenu
          }
          childItems {
            nodes {
              path
              label
              id
              menu_item_is_title {
                menuItemIsTitle
              }
              childItems {
                nodes {
                  path
                  label
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`

const EnglishNavList = ({ isActive, pageContext }) => {
  const items = useStaticQuery(ACFQuery).wpMenu.menuItems.nodes

  return <NavList {...{ isActive, items, pageContext }} />
}

export default EnglishNavList
